import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AbilitiesSelectors } from '@core/abilities-data';
import { Ability } from '@core/abilities-types';
import { AccountSelectors } from '@core/account-data';
import { BillingPlanTier } from '@core/billing-types';

import { WorkflowAutomationsAccessFacade } from './workflow-automations-access.facade';

@Injectable()
export class AutomationAccessService {
  private readonly store = inject(Store);
  private readonly workflowAutomationsAccessFacade = inject(WorkflowAutomationsAccessFacade);

  private readonly abilitiesMap = this.store.selectSignal(AbilitiesSelectors.abilityMap);

  public isAutomationReadOnly =
    !this.abilitiesMap()[Ability.ManageAutomatedActions] ||
    !this.workflowAutomationsAccessFacade.workflowAutomationsEntitled();

  public conditionsHaveUpsell =
    this.store.selectSignal(AccountSelectors.productCodename)() === BillingPlanTier.Grow;
  public conditionsAvailable =
    this.store.selectSignal(AccountSelectors.productCodename)() === BillingPlanTier.Optimize;
  public triggersHaveUpsell =
    this.store.selectSignal(AccountSelectors.productCodename)() === BillingPlanTier.Grow;

  public canManageCandidates = this.abilitiesMap()[Ability.ManageCandidates];
  public canViewCandidates = this.abilitiesMap()[Ability.ViewCandidates];
  public canManageAttributes = this.abilitiesMap()[Ability.ManageAttributes];
  public canPublishJobs = this.abilitiesMap()[Ability.PublishJobs];
  public canSendEmails = this.abilitiesMap()[Ability.SendEmails];
}
